const Roles = {
    CLIENT_FOLLOWER: 5,
    COURTESY_FOLLOWER: 7,
  };
  
  export default Roles;
  